/* eslint-disable */
export default {
  doNotCall: '請勿來電',
} as const;

// @key: @#@"doNotCall"@#@ @source: @#@"Do Not Call"@#@
